import {ColorsType, StyleType} from '../../../../styles';
import {SwitchSize, SwitchState} from './switch_types.web';

export const styles = (
  width: number,
  currentState: SwitchState,
  circleSize: number,
  borderWidth: number,
  active: boolean,
  colors: ColorsType,
  fontStyles: StyleType,
  size: SwitchSize,
) => ({
  switchContainer: {
    display: 'flex',
    alignItems: 'center' as 'center',
    gap: 8,
    cursor: currentState !== 'disable' ? 'pointer' : 'auto',
  } as React.CSSProperties,

  switch: {
    display: 'flex',
    alignItems: 'center' as 'center',
    width: width,
    height: parseInt(size) - borderWidth * 2,
    backgroundColor: active
      ? currentState === 'enable' || (currentState === 'hover' && !active)
        ? colors.primary700
        : currentState === 'hover'
        ? colors.primary900
        : colors.neutral400
      : 'transparent',
    borderRadius: 30,
    borderStyle: 'solid',
    borderWidth: borderWidth,
    borderColor:
      currentState === 'enable' || (currentState === 'hover' && !active)
        ? colors.primary700
        : currentState === 'hover'
        ? colors.primary900
        : colors.neutral400,
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
  } as React.CSSProperties,

  switchCircle: {
    width: circleSize - borderWidth * 2,
    height: circleSize - borderWidth * 2,
    backgroundColor:
      active && currentState !== 'disable'
        ? colors.neutral100
        : active && currentState === 'disable'
        ? colors.neutral200
        : 'transparent',
    borderRadius: '50%',
    position: 'relative',
    transform: active
      ? `translateX(${size === '32' ? 22 : 16}px)`
      : 'translateX(-1px)',
    transition:
      'transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease',
    borderWidth: active ? borderWidth - 1 : borderWidth,
    borderColor:
      active && currentState !== 'disable'
        ? colors.neutral100
        : active && currentState === 'disable'
        ? colors.neutral200
        : currentState === 'enable' || (currentState === 'hover' && !active)
        ? colors.primary700
        : currentState === 'hover'
        ? colors.primary900
        : colors.neutral400,
    borderStyle: 'solid' as 'solid',
  } as React.CSSProperties,

  text: {
    color: colors.neutral1000,
    ...fontStyles['bodyRegularMD'],
    lineHeight: fontStyles['bodyRegularMD']?.lineHeight + 'px',
    margin: 0,
  } as React.CSSProperties,
});
